const isEmpty = (value) =>
	value === undefined || value === null || value === "";

/**
 * Sprawdza poprawność adresu email
 *
 * @param {String} value
 * @returns {Boolean}
 */
export function email(value) {
	return (
		!isEmpty(value) &&
		/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
	);
}

/**
 * Sprawdza poprawność wprowadzonego hasła
 * z uwzględnieniem warunków długości,
 * zawartości liter i cyfr
 * oraz różnicy od nazwy profilu użytkownika.
 *
 * @param {String} value // hasło do sprawdzenia
 * @param {String} username // nazwa użytkownika - warunek aby hasło do profilu było inne niż nazwa użytkownika
 * @returns {Boolean}
 */
export function password(value, username) {
	return (
		value.match(/[^0-9]/g) &&
		value.match(/[0-9]/g) &&
		value !== username &&
		value.length >= 8
	);
}
